<template>
  <div>
    <div class="btn-wrapper mb-10 move-right grid-full">
      <transition name="fade" mode="out-in">
        <button
          @click.prevent=""
          v-if="showDeleteButton"
          class="btn-back mr-15"
        >
          <img src="/img/delete-1.svg" alt="delete" class="mr-5" />
          <span>Delete items</span>
        </button>
      </transition>
      <router-link to="/admin/hrm/leave/settings" class="btn-back">
        <span>Back</span>
      </router-link>
    </div>
    <div class="relative adjust-height">
      <div class="inner-table relative">
        <div :class="{ overlay: true, show: view }"></div>
        <div class="flex blue">Leave Type Setting</div>
        <div class="table-heading flex flex-v-center flex-h-bet">
          <div class="media-group flex"></div>
          <div class="relative leave-search">
            <img
              src="/img/search-icon.svg"
              alt="search team table"
              class="search-icon"
            />
            <el-input
              placeholder="Search"
              name="search"
              type="text"
              class="short mr-10"
              v-model="searchQuery"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div
            class="btn-wrapper mb-10 move-right"
            v-if="leaveTypeSettingsData.length"
          >
            <router-link
              to="/admin/hrm/leave/settings/leave-type/create"
              class="btn btn-blue btn-full-radius inline-flex flex-v-end"
            >
              <span> + New Leave Type</span>
            </router-link>
          </div>
        </div>
        <LeaveTypeSettingsTable
          @handleSelectionChange="handleSelectionChange"
          @toggleView="toggleView"
          :overlayLoading="overlayLoading"
          @resetTable="resetTable"
          :searchQuery="searchQuery"
          :data="leaveTypeSettingsData"
        />
        <LeaveSettingsTypeDetails :show="show" @toggleView="toggleView" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import LeaveTypeSettingsTable from "../components/LeaveTypeSettingsTable";
import LeaveSettingsTypeDetails from "../components/LeaveSettingsTypeDetails";
import debounce from "lodash.debounce";

const { mapState, mapActions } = createNamespacedHelpers("admin/hrm/leave");

export default {
  components: {
    LeaveTypeSettingsTable,
    LeaveSettingsTypeDetails,
  },
  data() {
    return {
      multipleSelection: [],
      loading: false,
      show: false,
      overlayLoading: false,
    };
  },
  computed: {
    ...mapState({
      view: "showViewContainer",
      leaveType: "currentLeaveType",
      employees: "Employees",
      leaveTypeSettingsData: "leaveTypes",
    }),
    showDeleteButton() {
      return this.multipleSelection.length;
    },
    searchQuery: {
      get() {
        return this.$store.state.admin.hrm.leave.searchQuery;
      },
      set(value) {
        return this.$store.commit("admin/hrm/leave/searchQuery", value);
      },
    },
  },
  methods: {
    resetTable() {
      this.searchQuery = "";
      this.getLeaveTypes();
    },
    ...mapActions(["getLeaveTypes", "getLeaveType", "deleteLeaveType"]),
    deleteLeaveType(id) {
      this.$promptModal(
        "Delete Leave Types",
        "This Leave types will be deleted",
        "Delete",
        () => this.handleDeleteLeaveType(id)
      );
    },
    handleDeleteLeaveType(id) {
      this.loading = true;
      this.deleteLeaveType(id)
        .then(() => {
          this.loading = false;
          this.getLeaveTypes();
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },
    search: debounce(function() {
      this.getLeaveTypes();
    }, 500),
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toggleView(row) {
      if (!row) {
        this.show = false;
        return;
      }
      this.overlayLoading = true;
      this.getLeaveType(row.id)
        .then(response => {
          this.currentLeaveType = response;
          this.show = !this.show;
          this.overlayLoading = false;
        })
        .catch(() => {
          this.show = false;
          this.overlayLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.leave-search {
  margin-left: auto;
}
</style>
